import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { BookingModel } from '../../models/api/BookingModel';
import { TherapistModel } from '../../models/api/TherapistModel';
import { BookingService } from '../../services/api/BookingService';
import { TherapistService } from '../../services/api/TherapistService';
import { AdminDashboardModel } from '../../models/api/AdminDashboardModel';
import { TherapistDashboardService } from '../../services/api/TherapistDashboardService';
import { DashboardService } from '../../services/api/DashboardService';
import { SiteConfigService } from '../../services/api/SiteConfigService';
import { SiteConfigModel } from '../../models/api/SiteConfigModel';
import { MatFormFieldModule } from '@angular/material/form-field';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { AuthService } from '../../services/auth/auth.service';


@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [MatIconModule, RouterModule, MatIcon, MatInputModule, MatButtonModule, FormsModule, MatFormFieldModule, ReactiveFormsModule, MatSnackBarModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})

export class DashboardComponent implements OnInit {


eventForm!: FormGroup;  
formSubmitted: boolean = false;
dashboardAdminModel: AdminDashboardModel = new AdminDashboardModel;
  siteConfigModel: SiteConfigModel = new SiteConfigModel;
  isAdmin: boolean = false;

  constructor(
    private matIconRegistry: MatIconRegistry, 
    private fb: FormBuilder, 
    private http: HttpClient, 
    private dashboardService: DashboardService, 
    private sanitizer: DomSanitizer, 
    private router: Router, 
    private bookingService: BookingService, 
    private therapistService: TherapistService,
    private siteConfigService: SiteConfigService,
    private authService: AuthService,
  private snackBar: MatSnackBar) {
    this.matIconRegistry.registerFontClassAlias('material-symbols-outlined', 'material-symbols-outlined');
  }

ngOnInit(): void {

  const user = this.authService.getAuthUserRecordFromLocalStorage();

  if (user && user.user.userTypeID === 1) {
    this.isAdmin = true;
  } else {
    this.isAdmin = true;
  }

  this.dashboardService.getAdminDashboard().subscribe(data => {
    this.dashboardAdminModel = data;
  })

    this.eventForm = this.fb.group({
    eventName: ['', Validators.required],
    siteConfigID: [0, Validators.required]
  })

  this.siteConfigService.getSiteConfig(1).subscribe(data => {
    this.siteConfigModel = data;
    this.eventForm.patchValue({
      siteConfigID: data.siteConfigID,
      eventName: data.eventName
    })
  })




}

  goToTherapists(therapistStatus: number) {
      this.router.navigate(['/admin/therapists']);
    //}
  }

  goToClockedIn() {
      this.router.navigate(['/admin/therapists/clocked-in']);
  }

  goToOnBreak() {
      this.router.navigate(['/admin/therapists/on-break']);
  }

    goToOnMassage() {
      this.router.navigate(['/admin/therapists/on-massage']);
  }

    goToWaiting() {
      this.router.navigate(['/admin/therapists/waiting']);
  }

  goToBookings(bookingStatus: number) {
    //if (this.isAdmin) {
      this.router.navigate(['/admin/bookings'], { state: { bookingStatus: bookingStatus } });
    //}
  }


  saveEventName(){
    this.formSubmitted = true;

    if (this.eventForm.valid){
      
      const siteConf: SiteConfigModel = this.eventForm.value;

      this.siteConfigService.updateSiteConfig(this.siteConfigModel.siteConfigID, siteConf).subscribe({
        next: (response) => {
          this.eventForm.markAsPristine();
          this.snackBar.open('Event name updated', 'Close',{
            duration: 5000,
            panelClass: "confirm-snackbar",
          });
        }
      })

    }


  }



}
